// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1__DG","cls2":"CollapsedActivityPreview-cls2_yzx CollapsedActivityPreview-cls1__DG"};